/*
 * © 2026 Ecsper Ltd. All rights reserved.
 * SPDX-License-Identifier: LicenseRef-Ecsper-Proprietary
 * Unauthorised use, copying, or distribution is strictly prohibited.
 */

import type { ReactElement } from 'react';
import { useEffect, useState } from 'react';

import { fetchAnalysis } from './fetchAnalysis.js';
import { RealAnalysisView } from './RealAnalysisView.js';
import { StubPanel } from './StubPanel.js';
import type { AnalysisResult, PanelProps } from './types.js';

export function EcsperChallengePanel({ reportId, apiClient }: PanelProps): ReactElement {
  const [analysis, setAnalysis] = useState<AnalysisResult | null>(null);
  const [isStub, setIsStub] = useState(true);

  useEffect(() => {
    let cancelled = false;
    void fetchAnalysis(apiClient, reportId, 'gap_analysis')
      .then((result) => {
        if (cancelled) {
          return;
        }
        setIsStub(result.stub);
        setAnalysis(result);
      })
      .catch(() => {
        if (!cancelled) {
          setIsStub(true);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [apiClient, reportId]);

  if (isStub) {
    return <StubPanel brand="challenge" />;
  }

  return <RealAnalysisView analysis={analysis} />;
}
